export default {
  userId(state) {
    return state.userInfo.userId;
  },
  token(state) {
    return state.token;
  },
  isAuthenticated(state) {
    return !!state.token;
  },
  didAutoLogout(state) {
    return state.didAutoLogout;
  },
  userInfo(state) {
    return state.userInfo;
  },
  rules(state) {
    return state.rules;
  },
  versionInfo(state) {
    return state.versionData;
  },
  needsRefresh(state) {
    return state.needsRefresh;
  },
};
